import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BusyIndicatorMessageManager } from '../../../Busy-Indicator';
import { ErrorLogRepository } from '../errorLog.repository';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { lastValueFrom } from 'rxjs';

export interface ErrorLogDetailsParams {
    errorLogId: number;
    errorLogGuid: string;
}

@Component({
    selector: 'error-log-details',
    templateUrl: './errorLogDetails.component.html',
    styleUrls: ['./errorLogDetails.component.scss'],
    standalone: false,
})
export class ErrorLogDetailsComponent implements OnInit, IWeissmanModalComponent<ErrorLogDetailsParams, void> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _errorLogRepository: ErrorLogRepository,
    ) {}

    busyIndicatorMessageManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager<string>();

    params: ErrorLogDetailsParams;
    result: void;

    errorLog: Core.ErrorLogModel;

    async ngOnInit(): Promise<void> {
        const busyMsgId = 'loading';
        this.busyIndicatorMessageManager.add('Loading', busyMsgId);

        try {
            let errorLog: Core.ErrorLogModel;
            if (this.params.errorLogId) {
                errorLog = await lastValueFrom(this._errorLogRepository.get(this.params.errorLogId));
            } else {
                errorLog = await lastValueFrom(this._errorLogRepository.getViaGuid(this.params.errorLogGuid));
            }

            this.errorLog = {
                ...errorLog,
                exception: errorLog.exception,
                json:
                    (errorLog.json ?? '').length < 100000
                        ? errorLog.json
                        : `${this.params.errorLogGuid} request JSON is too large to render, the request has been logged to the console.`,
            };

            if (errorLog.json) {
                try {
                    console.log(`${this.params.errorLogGuid}:`, JSON.parse(errorLog.json));
                } catch {
                    // Payload may be non-JSON or truncated; log the raw value instead of failing the modal.
                    console.log(`${this.params.errorLogGuid} (unparseable JSON):`, errorLog.json);
                }
            }
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    cancel(): void {
        this._bsModalRef.hide();
    }
}
